import { createContext, useContext } from 'react';
export var ComposeAppContext = createContext(null);
export var useComposeAppGlobalState = function useComposeAppGlobalState(selector) {
  return selector(useContext(ComposeAppContext).getState());
};